import { createSelector } from '@reduxjs/toolkit';
export const selectActiveTab = createSelector((state) => state, (tabSetState) => {
    if (!tabSetState) {
        return '';
    }
    for (const tabId in tabSetState) {
        if (tabSetState[tabId].isActive) {
            return tabSetState[tabId].id;
        }
    }
    return '';
});
export const selectActiveTabExpression = createSelector((state) => state, (tabSetState) => {
    const activeTabId = selectActiveTab(tabSetState);
    return activeTabId && tabSetState
        ? tabSetState[activeTabId].expression
        : '';
});
